import React from 'react'

const XCloseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 21 21" fill="none">
            <path d="M15.6665 5.54785L5.6665 15.5479M5.6665 5.54785L15.6665 15.5479" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default XCloseIcon
